import axios from "axios";
import {BASE_PATH} from "../services/api";

const getForecast = async (calc_id) => {
    return axios.get(BASE_PATH + "/admin/get-forecast/" + calc_id, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
};

const getForecastDates = async (calc_id) => {
    return axios.get(
        BASE_PATH + "/admin/get-forecast-dates/" + calc_id,
        {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        }
    );
};

export {getForecast, getForecastDates};
